import * as React from 'react';

import Barcodes from '../barcode/Barcodes';
import PrimaryFields from '../fields/PrimaryFields';
import SecondaryAndAuxiliaryFields from '../fields/SecondaryAndAuxiliaryFields';
import LogoTextHeaderFields from './LogoTextHeaderFields';
import ImagePreview from '../images/ImagePreview';
import { ImageTypes } from '../../../../types';
import { useStyles } from './styles';
import { useTheme } from '../../Theme';

export default function StoreCard(): JSX.Element {
  const theme = useTheme();
  const classes = useStyles({ theme });
  return (
    <>
      <LogoTextHeaderFields />
      <ImagePreview imageType={ImageTypes.strip} />
      <div className={classes.primaryFieldContainer}>
        <PrimaryFields />
      </div>
      <SecondaryAndAuxiliaryFields />
      <Barcodes />
    </>
  );
}
